import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { hourLabelForSegment, isHourLabelAtEnd, shouldShowHourLabel } from "../timer-calendar-view.mapper";
import { CalendarEnabledTimes, CalendarViewModel, HoursSegmentPresets } from "../timer-calendar-view.models";

@Component({
	selector: "app-calendar-timeline-header",
	templateUrl: "./calendar-timeline-header.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarTimelineHeaderComponent {
	@Input({ required: true }) vm!: Pick<
		CalendarViewModel,
		| "segmentIndices"
		| "segmentWidthPx"
		| "hourLabelOffsetPx"
		| "segmentsPerHour"
		| "dayStartHour"
		| "dayEndHour"
		| "startFromSchedule"
	>;
	@Input({ required: true }) enabledTimes!: CalendarEnabledTimes;

	private get layout() {
		return {
			preset: this.vm.segmentsPerHour as HoursSegmentPresets,
			fromWorkDay: false,
			fromSchedule: this.vm.startFromSchedule,
			segmentWidthPx: this.vm.segmentWidthPx,
			scheduleHourBounds: null as { startHour: number; endHour: number } | null,
		};
	}

	shouldShowHourLabel(seg: number): boolean {
		const total = this.vm.segmentIndices.length;
		return shouldShowHourLabel(
			seg,
			this.layout,
			this.vm.dayStartHour,
			this.vm.dayEndHour,
			this.vm.segmentsPerHour,
			total
		);
	}

	isHourLabelAtEnd(seg: number): boolean {
		const total = this.vm.segmentIndices.length;
		return isHourLabelAtEnd(seg, this.layout, this.vm.segmentsPerHour, total);
	}

	hourLabelForSegment(seg: number): number {
		const total = this.vm.segmentIndices.length;
		return hourLabelForSegment(
			seg,
			this.layout,
			this.vm.dayStartHour,
			this.vm.dayEndHour,
			this.vm.segmentsPerHour,
			total
		);
	}
}
